const OVERRIDDEN_COMPONENTS_PREFIX = 'Slots'

export const SlotsComponentsConfig = {
  path: '~/components/genesis/slots',
  global: true,
  prefix: OVERRIDDEN_COMPONENTS_PREFIX,
}

export enum SlotsComponents {
  AppSidebarBottom = `${OVERRIDDEN_COMPONENTS_PREFIX}AppSidebarBottom`,
  OrganizationDialogMembersDataTables = `${OVERRIDDEN_COMPONENTS_PREFIX}OrganizationDialogTabsMembersDataTablesMembersDataTable`,
  OrganizationDialogInvitationsDataTables = `${OVERRIDDEN_COMPONENTS_PREFIX}OrganizationDialogTabsMembersDataTablesInvitationsDataTable`,
}
